import { RECENT_BILLS_STATUSES } from "_constants/billing";

export function getRecentBillsStatus(orderStatus) {
  return RECENT_BILLS_STATUSES[orderStatus];
}

export function getActiveOrderUpsells(orders, orderId) {
  if (!Array.isArray(orders) || !orderId) return [];
  return orders.filter((order) => order.parentOrderUid === orderId);
}

export function findProduct({ orderDetails, upsells, productCodes, notCancelled }) {
  // search in main order
  const selectedProduct = orderDetails?.products?.find(({ code: { code } }) => productCodes.includes(code));

  if (selectedProduct) {
    const isDeclined = selectedProduct.paymentStatus === "Declined";
    const isLead = selectedProduct.processingResult?.status === "Lead";
    const isCancelled = selectedProduct.processingResult?.status === "Cancelled";

    if (!isDeclined && !isLead && (!notCancelled || !isCancelled)) {
      return selectedProduct;
    }
  }

  // search in upsells
  for (const upsell of upsells) {
    for (const product of upsell.products) {
      if (productCodes.includes(product.code.code)) {
        const isDeclined = product.paymentStatus === "Declined";
        const isLead = product.processingResult?.status === "Lead";
        const isCancelled = product.processingResult?.status === "Cancelled";

        if (!isDeclined && !isLead && (!notCancelled || !isCancelled)) {
          return product;
        }
      }
    }
  }

  return null;
}

export function findActiveProduct({ orders, orderId, productCodes, notCancelled }) {
  if (orders?.length === 0) return null;

  const orderDetails = orders?.find((o) => o.uid === orderId);

  if (!orderDetails) return null;

  const activeUpsells = getActiveOrderUpsells(orders, orderId);
  return findProduct({
    orderDetails,
    upsells: activeUpsells,
    productCodes,
    notCancelled,
  });
}
